/* eslint-disable */

import { View, /*YellowBox,*/ AppState, Linking, Text, Alert, Platform, Vibration } from 'react-native';
//import OneSignal from 'react-native-onesignal';
//import MessageQueue from 'react-native/Libraries/BatchedBridge/MessageQueue.js'
import { NavigationActions } from 'react-navigation';
import PostsActions from '../Redux/PostsRedux'
import { NativeBaseProvider } from 'native-base'

/*
YellowBox.ignoreWarnings([
  'Warning: componentWillMount is deprecated',
  'Warning: componentWillReceiveProps is deprecated',
  'Warning: componentWillUpdate is deprecated',
]);
*/

import '../Config'
import DebugConfig from '../Config/DebugConfig'
import { KargoeConfig } from '../Config/AppConfig'
import React, { Component } from 'react'
import { Provider, connect } from 'react-redux'
import RootContainer from './RootContainer'
import createStore from '../Redux'
import { api } from '../Sagas/index'
import { Fonts } from '../Themes'
import Outofdate from '../Containers/outofdate'
import NotificationManager from '../Lib/NotificationManager'
import { OfflineMessaging } from '../Services/OfflineMessaging'
import AuthActions from '../Redux/AuthRedux'
import API from '../Services/Api'
/*
import RNIap, {
  purchaseErrorListener,
  purchaseUpdatedListener,
  // type ProductPurchase,
  // type PurchaseError
  InAppPurchase, SubscriptionPurchase, ProductPurchase, PurchaseError
} from 'react-native-iap'
*/
const PushActions = {
  NOTIFY_MESSAGE : 1
, NOTIFY_LIKE : 2
, NOTIFY_COMMENT : 4
, NOTIFY_TAGGED_IN_POST : 8
, NOTIFY_BUYER_ORDER : 16
, NOTIFY_SELLER_ORDER : 32
, NOTIFY_ENDORSER_ORDER : 64
, NOTIFY_WHEN_TO_POST : 128
, NOTIFY_BEING_FOLLOWED : 256
, NOTIFY_STREAM_STARTING : 512
}

const spyFunction = (msg) => { console.log("spy on bridge: ", msg); }
// dont do for prod or test flight:  
//MessageQueue.spy(spyFunction)

/* for tracing timeout and interval calls
const origSetTimeout = setTimeout
const origSetInterval = setInterval

setTimeout = (a, b) => {
  console.log("setTimeout for " + b + " " + a)
  console.trace() // not working, browser only?
  origSetTimeout(a, b)
}

setInterval = (a, b) => {
  console.log("setInterval for " + b + " " + a)
  console.trace() // not working, browser only?
  origSetInterval(a, b)
}
*/

const store = createStore()
/**
 * Provides an entry point into our application.  Both index.ios.js and index.android.js
 * call this component first.
 *
 * We create our Redux store here, put it into a provider and then bring in our
 * RootContainer.
 *
 * We separate like this to play nice with React Native's hot reloading.
 */
import '../Config/ReactotronConfig'
//import Snoopy from 'rn-snoopy';
//import { stringify } from 'rn-snoopy/formatting';
//import bars from 'rn-snoopy/stream/bars';
//import filter from 'rn-snoopy/stream/filter';
//import buffer from 'rn-snoopy/stream/buffer';
import stringify from 'json-stringify-safe'

//import EventEmitter from 'react-native/Libraries/vendor/emitter/EventEmitter';
const __DEV__ = false
if (__DEV__) {
  //const emitter = new EventEmitter();

  //const events = Snoopy.stream(emitter);
  //filter({ type: Snoopy.TO_NATIVE }, true)(events).subscribe()
  filter(info => info.method == 'playVideo', true)(events).subscribe();
  // bars()(
  //   buffer()(
  //     events
  //   )
  // ).subscribe()


  // bars(info=>JSON.stringify(info.args).length)(
  //   events
  // ).subscribe()


  // bars(info=>JSON.stringify(info.args).length,
  //   100 /*command string length threshold*/,
  //   true /*show yellow box*/
  // )(events).subscribe()


  // bars(info=>JSON.stringify(info.args).length)(
  //     filter({ method:'createView' })(events)
  // ).subscribe()
}

// note:  requires modified json-stringify-safe so it calls this origStringify,
// or else we get recursive loop
if (!JSON.origStringify) JSON.origStringify = JSON.stringify // safe stringify should call this
JSON.stringify = stringify

// Find uses of the Text component where the fontFamily (or color) are undefined by setting them to something distinctive or default it
let oldRender = Text.render;

// even w/ changes, this breaks stuff on web, styles set in the app dont get thru
// the patches here were treating origin.props.style as an object but maybe need
// to think that it may be an array 
// may be issues on array of styles in this lower level react API on react-native-web

// noted Dec 1 2021 similar crash on firefox in CaptionCommentView main wall (large image)

if (false) // remove for chrome, causing crash in display of comments on wall, <Text> within <Text>, something to do with style (maybe originl.props.style is undef?)
// to see the bug, set above false to true, then build or react-native-web and run on chrome
Text.render = function (...args) {
    let origin = oldRender.call(this, ...args);
    // web restructure, doesnt like array of styles or possibly null style 
    // so get rid of array and only add in styles if they exist
    let styleObj = {fontFamily: Fonts.style.font.regular}
    if (origin && origin.props && origin.props.style) {
      let keys = Object.keys(origin.props.style)
      for (let i = 0; i < keys.length; i++) {
        let val = origin.props.style[keys[i]]
        styleObj[keys[i]] = val
      }
    }
    return React.cloneElement(origin, {
        // style: [{color: 'green', fontFamily: 'Zapfino'}, origin.props.style]
        style: [/*{fontFamily: Fonts.style.font.regular}, origin.props.style*/styleObj]
    })
}

class App extends Component {
  purchaseUpdateSubscription = null
  purchaseErrorSubscription = null
  state = {
    appState: AppState.currentState,
    renderBump: 0
  }
  api = API.create()
  
  // App is initialized
  componentDidMount( ) {
    this.setState({ outofdate : false, needsLoginTimeStamp : null })
    store.dispatch({ type: 'WEBSOCKET_INIT' })
    AppState.addEventListener('change', this.resumeFromBackground)
    let auth = store.getState( ).auth.user
    if( auth ) OfflineMessaging.init(auth.UserId)

    if (Platform.OS == 'web') {

      https://stackoverflow.com/questions/11381673/detecting-a-mobile-browser

      window.isMobile = function() {
        let check = false;
        (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
        return check;
      };

      window.addEventListener('resize', () => {
        console.info("got resize")
        // try 1 works a little but doesnt resize top and bottom bars only wall and
        // wall goes kind of funny, double column
        // this.setState({renderBump: this.state.renderBump + 1})
        if (!window.isMobile())
          window.location = window.location
      })
    }
    
  }

  // App is being destroyed
  componentWillUnmount() {
    AppState.removeEventListener('change', this.resumeFromBackground)

    if (this.purchaseUpdateSubscription) {
      this.purchaseUpdateSubscription.remove();
      this.purchaseUpdateSubscription = null;
    }
    if (this.purchaseErrorSubscription) {
      this.purchaseErrorSubscription.remove();
      this.purchaseErrorSubscription = null;
    }
  }

  // App is resumed from the background
  resumeFromBackground = (nextAppState) => {
    if (this.state.appState.match(/inactive|background/) && nextAppState === 'active') {
      let auth = store.getState( ).auth.user
      if (auth) {
        OfflineMessaging.init(auth.UserId)
        const notifId = auth.NotificationId
        console.log(`resumeFromBackground connecting to OneSignal with ${notifId}`)
        try {
          //OneSignal.sendTag('kargoe_username', notifId)
        }
        catch (e) {
          console.log(`resumeFromBackground OneSignal.sendTag failed: ${e.message}`)
        }
      }
      // App is entering the foreground in this render cycle
      NotificationManager.postNotificationWithString("AppDelegate_printf", "ready to call store.dispatch WEBSOCKET_INIT")
      store.dispatch({ type: 'WEBSOCKET_INIT' }) // I Did Make Things Crash in iOS 10/11 but not iOS 12, see wserr
      NotificationManager.postNotificationWithString("AppDelegate_printf", "after call to store.dispatch WEBSOCKET_INIT ready to set state outofdate false")
      this.setState({ outofdate : false, needsLoginTimeStamp : null })
      NotificationManager.postNotificationWithString("AppDelegate_printf", "after set state out of date false should be triggering renders soon")

    } else if (nextAppState === 'background') {
      store.dispatch({ type: 'WEBSOCKET_DISCONNECT' })
    }
    this.setState({ appState: nextAppState })
  }

  // One Signal init
  componentWillMount( ) {
    console.log(`componentWillMount OneSignal`)
    this.OSf = { recv : this.onReceived.bind(this), open : this.onOpened.bind(this), ids : this.onIds.bind(this) }
    // provisioning profiles for dev and testflight (production) must be regenerated After the special Push Notification Provisioning profile is made
    // the special Push Notification Provisioning profile then needs to be uploaded to the OneSignal site.
    // there is a wizard on the one signal site to generate this special push notification profile
    // krgovndevcam:  "6337d531-fede-4ba9-870f-60b93ffad772"
    // note:  none of these callbacks do anything yet except log to console
    // delay this so user doesnt get popup on login / signup screen
    // can think of a better way later (e.g. once we get a token, can do this)
      // allow normal iOS notifs to show in-app

      //OneSignal.init(KargoeConfig.oneSignalKey, // note, this number will change based upon the app bundle id see onesignal.com console
      //{kOSSettingsKeyInFocusDisplayOption : 0,  // 2 = show ios alerts when app is in foreground, 0 = no in app notifs
      //kOSSettingsKeyAutoPrompt : false});        // false = dont prompt now for user permission
                                                  // do in wall display or later in app launch
                                                  // via OneSignal.registerForPushNotifications()

      //OneSignal.addEventListener('received', this.OSf.recv)
      //OneSignal.addEventListener('opened', this.OSf.open)
      //OneSignal.addEventListener('ids', this.OSf.ids)

    api.api.setState = this.setState.bind(this)
  }

  componentWillUnmount() {
    //OneSignal.removeEventListener('received', this.OSf.recv)
    //OneSignal.removeEventListener('opened', this.OSf.open)
    //OneSignal.removeEventListener('ids', this.OSf.ids)
  }

  onReceived(notification) {
    console.log("Notification received: ", notification);

    Vibration.vibrate()

    // if we are in postview (Post Detail title), refresh just in case this is another comment
    // later can check the particular notification type, now just try for all
    let nav = this.navigation ( ) // copy from onOpened
    console.log("onRecvd, nav state = " + JSON.stringify(nav.state, null, 2)) // yields undefined, great 
    let timeStamp = 0
    if (notification.payload && notification.payload.additionalData)
      timeStamp = notification.payload.additionalData.TimeStamp

    if (nav.state.routes && nav.state.routes.length > 0) {
      const topRoute = nav.state.routes[nav.state.routes.length - 1]
      if (topRoute.routeName == 'postView') {
        if (notification.payload && notification.payload.additionalData) {
           const postId = notification.payload.additionalData.PostId
           console.log('trying to refresh post comments due to notification recvd while in post view')
           store.dispatch(PostsActions.readPostRequest({ PostId: postId }))
        }
      }
    }
  }

  getUsernameThenGoToMessages = (nav, UserId) => {
    // this info may not be in place yet from the saga redux stuff if app is just launched
    const s = store.getState( )
    if (s.auth && s.auth.user) {
      let PhoneUserId = store.getState( ).auth.user.UserId
        , responses = Promise.all([ api.readUser(UserId), api.readUser(PhoneUserId) ])
      responses.then( ab => {
        let OtherUser = ab[0] && ab[0].ok && ab[0].data.data[0]
          , PhoneUser = ab[1] && ab[1].ok && ab[1].data.data[0]
        if( OtherUser && PhoneUser )
          nav.navigate('chat',  { PhoneUser : PhoneUser
                                , OtherUserId : UserId
                                , OtherUserName : OtherUser.Username
                                , isScroll : true })
      }).catch(console.warn)
    }
    else {
      // this gets triggered when app is launched by user's notification tap (not coming from background)
      console.log("caution, cannot go to message because we are not a validated user yet")
      //alert("caution, cannot go to message because we are not a validated user yet")
      // yeah this is happening, so retry after a moment
      // maybe don't want to do this more than some count for safety
      // backstop this
      if (!this.goToMessageCount) this.goToMessageCount = 1
      else this.goToMessageCount++
      if (this.goToMessageCount < 5) setTimeout(this.getUsernameThenGoToMessages.bind(this, nav, UserId), 3000)
    }
  }
  // optional time stamp of comment to try to scroll to in a post 
  getPostThenGoToProfile = (nav, PostId, isMention, timeStamp) => {
    api.readPost({ PostId : PostId })
    .then(resp => {
      if( resp.ok ) {
        //alert("PostId = " + PostId + "\nUserId = " + resp.data.data[0].UserId)
        console.log('read to navigate to profile but if we are already there... hmmm')
        // hack is to nav home first
        // doesnt work causes a red screen nav.navigate('home')
        // relogin sagas may be interfering if we are already on profile

        // this is in case you are already on profile screen, just doing the navigate to profile does nothing
        // e.g. doesnt scroll to the proper post and does not open PostView if necessary
        // there may be a way to make this more efficient by catching the new nav params in did component update (?)
        // in post wall base but this seems like it may work
        // can we do it w/o the setTimeout?  e.g. after home transition is done?  that requires more study
        // maybe a transition listener?
        nav.dispatch(NavigationActions.reset({
          index: 0,
          key: null,
          actions: [NavigationActions.navigate({ routeName: 'home', params: { isScroll : true } })]
        }))

        setTimeout(() =>
          nav.navigate('profile', { postId : PostId, userId : resp.data.data[0].UserId, thenOpenPostView : isMention, TimeStamp : timeStamp}), 
          100)
      }
      else {
        // this is definitely happening from cold start (not background)
        //alert("caution, cannot go to profile, api.readPost failed")
        if (!this.goToProfileCount) this.goToProfileCount = 1
        else this.goToProfileCount++
        if (this.goToProfileCount < 5) setTimeout(this.getPostThenGoToProfile.bind(this, nav, PostId, isMention), 3000)
      }
    }).catch(alert.bind(this, "caution, caught error get post then go to profile")) // this is not happening at cold start tap notif
  }
  navigation = ( ) => {
    return ( this.rootContainer && this.rootContainer.navigation )
            ? this.rootContainer.navigation
            : false
  }
  onOpened(openResult) {
    if( openResult && openResult.notification && openResult.notification.payload ) {
      let payload = openResult.notification.payload
        , kargoeData = payload.additionalData
        , nav = this.navigation ( )
      console.log("notification openResult = " + JSON.stringify(openResult))

      let alertText = '' // what gets shown by apple
      
      if (openResult.notification && 
        openResult.notification.payload && 
        openResult.notification.payload.rawPayload &&
        openResult.notification.payload.rawPayload.aps)
            alertText = openResult.notification.payload.rawPayload.aps.alert

      const isMention = alertText.indexOf('mentioned') >= 0

      // TimeStamp of post comment
      let timeStamp = 0
      if (openResult.notification.payload && openResult.notification.payload.additionalData)
        timeStamp = openResult.notification.payload.additionalData.TimeStamp

      console.log("notification isMention = " + isMention + " timeStamp = " + timeStamp)

      if( nav === false || typeof kargoeData !== 'object' ) return
      switch( kargoeData.ActionId ) {
        case PushActions.NOTIFY_MESSAGE:
          this.getUsernameThenGoToMessages(nav, kargoeData.UserId)
          break
        case PushActions.NOTIFY_LIKE:
        case PushActions.NOTIFY_COMMENT:
        case PushActions.NOTIFY_TAGGED_IN_POST:
        case PushActions.NOTIFY_STREAM_STARTING:
          this.getPostThenGoToProfile(nav, kargoeData.PostId, isMention, timeStamp)
          break
        case PushActions.NOTIFY_BUYER_ORDER:
        case PushActions.NOTIFY_SELLER_ORDER:
          //if (kargoeData) alert("kargoeData.Id = " + kargoeData.Id) // this seems to be occurring
          //else alert("got notify buyer or seller but no kargoeData")
          // doesnt crash when from background, does crash from cold start
          setTimeout(function( ) { // wait to avoid crash
            nav.navigate('kargoelyticDetail', { orderId: kargoeData.Id })
          }, 6000)
          break
        case PushActions.NOTIFY_ENDORSER_ORDER:
          setTimeout(function( ) { // wait to avoid crash (not sure if this will work or not, need to test)
            nav.navigate('kargoelytics')
          }, 6000)
          break
        case PushActions.NOTIFY_WHEN_TO_POST:
          nav.navigate('happening')
          break
        default: break
      }
    }
    console.log('Message: ', openResult.notification.payload.body);
    console.log('Data: ', openResult.notification.payload.additionalData);
    console.log('isActive: ', openResult.notification.isAppInFocus);
    console.log('openResult: ', openResult);
  }

  onIds(device) {
    console.log('Device info: ', device);
  }
  // end OneSignal init

  render() {
    
    NotificationManager.postNotificationWithString("AppDelegate_printf", "render() in App.js")
    const needsLoginTimeStamp = typeof this.state.needsLoginTimeStamp != 'undefined' ? this.state.needsLoginTimeStamp : null

    console.log("app.js render")

    return (
      <NativeBaseProvider key={"nativeBase" + this.state.renderBump}>
      <Provider store={store}>
        {false && this.state.outofdate
          ? (<Outofdate />)
          : (<RootContainer needsLoginTimeStamp={needsLoginTimeStamp} ref={ref => this.rootContainer=ref?ref.wrappedInstance:null}/>)
        }
      </Provider>
      </NativeBaseProvider>
    )
  }
}

// allow reactotron overlay for fast design in dev mode
export default false /*DebugConfig.useReactotron*/
  ? console.tron.overlay(App)
  : App
// export default  App
